module.exports = __webpack_public_path__ + "static/media/emptyContact.6f3351c6.svg";